import * as React from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { Post } from "../services/http";
import { validateForm } from "../services/validate";
import { Terms } from "./tems-text";
import UploadImage from "../services/upload-image";
import "./dialog.css";

export default function TermsPopup({ campaignId, campaignSlug, updateTermsPopup }) {
  const [open, setOpen] = React.useState(false);
  const [image, setImage] = React.useState(null);
  const [partnerLink, setPartnerLink] = React.useState(null);
  const openInfoPopup = useStoreActions((actions) => actions.open);
  const config = useStoreState((state) => state.config);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const createPartnerLink = (event) => {
    const partnerUserName = document.getElementById(event.target.id).value;
    const linkReady = config.frontDomain + campaignSlug + "/" + partnerUserName;
    setPartnerLink(linkReady);
  };

  const createAmbassador = async () => {
    console.log("image", image);
    let validationResult = validateForm(
      ["first-name", "last-name", "cell", "email", "goal", "slug", "password"],
      image
    );
    if (!validationResult.result) {
      openInfoPopup({ notice: validationResult.notice, reload: false, btnName: "OK" });
      return;
    }
    let firstName = document.getElementById("first-name").value;
    let lastName = document.getElementById("last-name").value;
    let cell = document.getElementById("cell").value;
    let email = document.getElementById("email").value;
    let goal = Number(document.getElementById("goal").value);
    let personalMessage = document.getElementById("personal-message").value;
    let slug = document.getElementById("slug").value;
    let password = document.getElementById("password").value;
    let additionalComments = document.getElementById("additional-comments").value;
    const result = await Post("/api/donation/CreateNewAmbassador", {
      goal,
      password,
      additionalComments,
      personalMessage,
      slug,
      phoneNumber: cell,
      email,
      firstName,
      secondName: lastName,
      campaignId: campaignId,
      img: image,
    });
    if (result.result) {
      openInfoPopup({ notice: "Created", reload: false, btnName: "OK" });
    } else {
      openInfoPopup({ notice: result.message, reload: false, btnName: "OK" });
    }
  };

  return (
    <div>
      <div id="popup-atboard" onClick={() => updateTermsPopup(false)} className="popup _open">
        <div className="popup__body">
          <div className="popup__content">
            <div onClick={() => updateTermsPopup(false)} className="popup__close">
              <img src="/img/sprite/close.svg" alt="" />
            </div>
            {/* <div className="popup__logo">
                            <img src="/img/logo-footer.png" alt="" />
                        </div> */}
            <div className="jb-wrap" style={{ position: "relative" }}>
              {/* <div className="popup__title"> Terms of use</div> */}
              <div>
                <p className="title-terms center roboto weight-500 f-24 mb-0 color-5">
                  Tomchei Tzedaka Corp DBA World of Tzedaka
                </p>
                <p className="title-terms center rubik weight-600 f-40 mb-0 color-1">
                  Terms and User Agreement
                </p>
                <div className="scroll-span" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                  <div className="title-terms gray rubik weight-400 f-16 color-5 text-justify">
                    This Terms and User Agreement (“Agreement”) constitutes a legally binding
                    agreement made between the user, whether personally or on behalf of an entity
                    (“user” or “you”) and Tomchei Tzedaka Corp DBA World of Tzedaka and its
                    affiliated companies (collectively, “company” or “we” or “us” or “our”),
                    concerning your access to and use of the www. worldoftzedaka.org website as well
                    as any other media form, media channel, mobile website or mobile application
                    related or connected thereto (collectively, the “website”). The Website provides
                    a platform to fundraise for a variety of causes (“company services”).
                    Supplemental terms and conditions or documents that may be posted on the Website
                    from time to time, are hereby expressly incorporated into this Agreement by this
                    reference.
                    <br />
                    The company makes no representation that the website is appropriate or available
                    in other locations other than where it is operated by the company. The
                    information provided on the website is not intended for distribution or use by
                    any person or entity in any jurisdiction or country where such distribution or
                    use would be contrary to law or regulation or which would subject the company to
                    any registration requirement within such jurisdiction or country. Accordingly,
                    those persons who choose to access the website from other locations do so on
                    their own initiative and are solely responsible for compliance with local laws,
                    if and to the extent local laws are applicable. All persons who are minors in
                    the jurisdiction in which they reside (generally under the age of 18) are not
                    permitted to register for the website or use the company services.
                  </div>
                  <p
                    className="text-justify rubik weight-500 f-16 color-5"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    THESE TERMS CONTAIN AN ARBITRATION AGREEMENT, WHICH WILL WITH LIMITED EXCEPTION,
                    REQUIRE YOU TO SUBMIT CLAIMS YOU HAVE AGAINST US TO BINDING AND FINAL
                    ARBITRATION. UNDER THE ARBITRATION AGREEMENT, (1) YOU WILL ONLY BE PERMITTED TO
                    PURSUE CLAIMS AGAINST THE COMPANY ON AN INDIVIDUAL BASIS, NOT AS A PLAINTIFF OR
                    CLASS MEMBER IN ANY CLASS OR REPRESENTATIVE ACTION OR PROCEEDING, AND (2) YOU
                    WILL ONLY BE PERMITTED TO SEEK RELIEF (INCLUDING MONETARY, INJUNCTIVE, AND
                    DECLARATORY RELIEF) ON AN INDIVIDUAL BASIS.
                  </p>
                  Your continuation with our registration process and use of our website and the
                  services within constitute your agreement to be bound by our terms and user
                  agreement. Entering into this agreement as a representative of an organization or
                  legal entity is a statement that you are authorized to do so. If you are under 18
                  years old or do not have authority to make this agreement, please discontinue use
                  of our website immediately. If you do not agree to abide by this agreement or to
                  amendments made to this agreement in the future, please discontinue use of our
                  website immediately.
                  <br />
                  <div
                    className="t-center color-1 rubik f-32 weight-500"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    {" "}
                    COMPANY SERVICES{" "}
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    The company provides the company services as a service for organizations,
                    entities, and individuals (the “fundraisers”) to raise funds for specific causes
                    (via a “campaign”). The company is not affiliated with any of the fundraisers.
                    While the company does perform a specified level of verification (as defined
                    below) regarding the fundraisers and campaigns, the company does not take any
                    responsibility for the conduct of any fundraiser, or the authenticity of the
                    fundraisers or the legitimacy of the campaigns, and all persons donating to a
                    campaign (the “Donors”), hereby waive all right of action against the company
                    arising from the actions of a fundraiser, or the legitimacy of a campaign.
                  </span>
                  <br />
                  <div
                    className="t-center color-1 rubik f-32 weight-500"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Verification
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    All individuals and organizations affiliated with the campaigns that we run have
                    been verified by Vaad Hatzedaka of Lakewood. The company only works with
                    individuals and organizations that have been verified by the Vaad Hatzedaka of
                    Lakewood. Fundraiser’s that are listed as non-profit organizations have provided
                    us with a non-profit tax identification number. However, the company does not
                    independently verify that each non-profit tax identification number is accurate,
                    authentic or current. The company takes no responsibility and will not be liable
                    for any failure of donations to qualify as charitable donations under applicable
                    tax law. Donors should consult with their tax advisors to determine the tax
                    deductibility of any donations.
                  </span>
                  <div
                    className="t-center weight-500 f-32 color-1"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Cancellation and Rejection of Campaigns and Donations
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    The company reserves the absolute right to accept, reject, cancel, or suspend
                    any campaign for any reason, or for no reason at all. The company is not
                    required to give any reason to reject, cancel, or suspend a campaign at any
                    time. Similarly, the company may reject or cancel any donation made at any time
                    at its sole discretion. The company shall have no liability to fundraisers or
                    donors for any actions taken by us under this section.
                  </span>
                  <div
                    className="t-center weight-500 f-32 color-1"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Allocation of Donated Funds
                  </div>
                  <span className="rubik weight-400 color-4">
                    When the donor makes a reference to a specific campaign or sites a campaign
                    number, it will be treated as advice for the allocation of the donated funds.
                    Actual allocation of funds is purely at the discretion of the company team.
                  </span>
                  <div
                    className="t-center weight-500 rubik color-1 f-32"
                    style={{ margintTop: "10px", marginBottom: "10px" }}
                  >
                    Refund Policy
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    All donations are final. There are absolutely no refunds.
                  </span>
                  <div
                    className="t-center weight-500 rubik color-1 f-32"
                    style={{ margintTop: "10px", marginBottom: "10px" }}
                  >
                    Donor Information
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    Sharing donor information with the fundraiser will be handled at the discretion
                    of the company. Those who wish to remain anonymous may make such a request and
                    it will be honored. Public donor information on the company website listed
                    within each campaign will contain the name of the donor and amount of the
                    donation unless the donor chooses to remain anonymous.
                  </span>
                  <div
                    className="t-center weight-500 rubik color-1 f-32"
                    style={{ margintTop: "10px", marginBottom: "10px" }}
                  >
                    Special Circumstances
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    Occasionally, there may be special circumstance that arise which are not
                    predicted within the text of these terms. The company may take below actions in
                    order to preserve its integrity as well as that of the campaigns and their
                    fundraisers.
                    <br />
                    We reserve the right to place a hold on a campaign account, restrict withdrawals
                    (defined herein), initiate a reverse transfer, secure reserves, or take similar
                    actions to protect our interests and those of our users. Disclosure of our
                    reason is at our sole discretion.
                    <br />
                    The company may, at any time, for any reason, without notice, and at its sole
                    discretion, offer or issue a refund of donations with or without consulting with
                    you, which may be up to the entire amount donated to your campaign. The company
                    is not liable to you or to any third party for any claims, damages, costs,
                    losses, or other consequences caused by the company issuing refunds, including,
                    but not limited to transaction or overdraft fees.
                  </span>
                  <div
                    className="t-center weight-500 rubik color-1 f-32"
                    style={{ margintTop: "10px", marginBottom: "10px" }}
                  >
                    {" "}
                    Fees and Commissions
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    The company does not charge platform fees, nor do we charge a percentage of
                    earned funds to any campaign. We do have a $28 per month membership fee. Costs
                    for building a campaign and advertising are deducted from the first campaign
                    earnings. The company reserves the right to market any campaign at its
                    discretion and costs will also be deducted from the campaign earnings. The
                    remainder of the earned funds go directly to the fundraiser at the sole
                    discretion of the company unless contraindicated by any other terms in this
                    document.
                  </span>
                  <div
                    className="t-center weight-500 rubik color-1 f-32"
                    style={{ margintTop: "10px", marginBottom: "10px" }}
                  >
                    Withdrawals from Campaign
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    When fundraisers wish to withdraw funds from their campaign they will submit a
                    request for campaign funds to{" "}
                    <a className="title-terms blue" href="mailto:info@worldoftzedaka.org">
                      info@worldoftzedaka.org
                    </a>{" "}
                    The company will review the request and upon approval they will send the funds
                    via channels that are available to the company at that time. Disapprovals do not
                    require explanation or reason. Any fees incurred for transfer of funds will be
                    deducted from the campaign balance. All donated funds will only be available to
                    withdraw after the company has made a satisfactory verification of the funds.
                  </span>
                  <div
                    className="t-center weight-500 rubik color-1 f-32"
                    style={{ margintTop: "10px", marginBottom: "10px" }}
                  >
                    Donor Dispute Resolution
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    In the even that a donor has a dispute for funds given, regardless of how the
                    funds were donated, if the fundraiser already received the funds, then the
                    fundraiser is required to immediately upon notification return the funds to the
                    company.
                    <br />
                    <br />
                  </span>
                  <div
                    className="t-center weight-500 rubik color-1 f-32"
                    style={{ margintTop: "10px", marginBottom: "10px" }}
                  >
                    Accuracy of User Information
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    By using the company services, you represent and warrant that:
                    <br /> 1. All information you submit to our website is truthful and accurate
                    <br />
                    2. Any changes to the above information will be updated immediately
                    <br />
                    3. Your account will be used responsibly and securely
                    <br />
                    4. You are legally authorized by state and company to act as a representative
                    <br />
                    5. No applicable laws or regulations will be violated by your use of company
                    services.
                    <br />
                    The fundraiser shall represent and warrant that (a) all information you provide
                    in connection with a campaign is accurate, complete, and not fraudulent or
                    deceptive and (b) all donations contributed to your campaign will be used for
                    the sole purpose of the cause that you present within the campaign and all
                    materials surrounding the campaign.
                    <br />
                    Any information that is believed to be false, inaccurate, or fraudulent may
                    result in termination of your account which may include termination of all
                    future relationships with the company. You must notify the company immediately
                    of any breach of security or unauthorized use of your account.
                    <br />
                    You are liable to the company for the violation of this agreement by anyone that
                    you have given access to your account. You are also liable for any person who
                    gains access to your account as a result of your failure to use reasonable
                    security precautions. Your responsibility to the company includes but is not
                    limited to any fees arising from the use of the company services or any other
                    part of our website.
                  </span>
                  <div
                    className="t-center weight-500 rubik color-1 f-32"
                    style={{ margintTop: "10px", marginBottom: "10px" }}
                  >
                    Fundraiser Provided Input
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    Our website may provide you with the opportunity to create, submit, post,
                    display, publish, distribute, or broadcast content and materials to our website,
                    including, but not limited to text, video, audio, photographs, graphics,
                    comments, suggestions, personally identifiable information, or other material
                    (collectively “input”). Any input you transmit to our website will be treated as
                    non-confidential and non-proprietary. When you add any input, you thereby
                    represent and warrant that:
                    <br />
                    a. the creation, distribution, transmission, public display and performance,
                    accessing, downloading and copying of your input does not and will not infringe
                    the proprietary rights, including but not limited to the copyright, patent,
                    trademark, trade secret or moral rights of any third party;
                    <br />
                    b. you are the creator and owner of or have the necessary licenses, rights,
                    consents, releases and permissions to use and to authorize the company and the
                    website users to use your inputs as necessary to exercise the licenses granted
                    by you under this Agreement;
                    <br />
                    c. you have the written consent, release, and/or permission of each and every
                    identifiable individual person in the input to use the name or likeness of each
                    and every such identifiable individual person to enable inclusion and use of the
                    input in the manner contemplated by this website;
                    <br />
                    d. your input is not obscene, lewd, lascivious, filthy, violent, harassing or
                    otherwise objectionable (as determined by the company), libelous or slanderous,
                    does not ridicule, mock, disparage, intimidate or abuse anyone, does not
                    advocate the violent overthrow of any government, does not incite, encourage or
                    threaten physical harm against another, does not violate any applicable law,
                    regulation, or rule, and does not violate the privacy or publicity rights of any
                    third party;
                    <br />
                    e. your input does not include any offensive comments that are connected to
                    race, national origin, gender, sexual preference or physical handicap; and
                    <br /> f. your input does not otherwise violate, or link to material that
                    violates, any provision of this agreement or any applicable law or regulation.
                    <br /> g. You will be obligated to provide campaign related information at any
                    point that it is requested from the company.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Input License
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    <br />
                    By posting input to any part of the website, or making it accessible to the
                    website by linking your account to any of your social network accounts, you
                    automatically grant, and you represent and warrant that you have the right to
                    grant, to the company an unrestricted, unconditional, unlimited, irrevocable,
                    perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide
                    right and license to host, use, copy, reproduce, disclose, sell, resell,
                    publish, broadcast, retitle, archive, store, cache, publicly perform, publicly
                    display, reformat, translate, transmit, excerpt (in whole or in part) and
                    distribute such Input (including, without limitation, your image and voice) for
                    any purpose, commercial, advertising, or otherwise, to prepare derivative works
                    of, or incorporate into other works, such Input, and to grant and authorize
                    sublicenses of the foregoing. The use and distribution may occur in any media
                    formats and through any media channels. Such use and distribution license will
                    apply to any form, media, or technology now known or hereafter developed, and
                    includes our use of your name, the company name, and franchise name, as
                    applicable, and any of the trademarks, service marks, trade names and logos,
                    personal and commercial images you provide. The company does not assert any
                    ownership over your Input; rather, as between us and you, subject to the rights
                    granted to us in this agreement, you retain full ownership of all of your Input
                    and any intellectual property rights, or other proprietary rights associated
                    with your input.
                    <br /> The company has the right, in our sole and absolute discretion, to (i)
                    edit, redact or otherwise change any input, (ii) re-categorize any input to
                    place them in more appropriate locations or (iii) pre-screen or delete any input
                    that are determined to be inappropriate or otherwise in violation of this
                    agreement.
                    <br />
                    The company reserves the right to take steps the company believes are reasonably
                    necessary or appropriate to enforce and/or verify compliance with any part of
                    this agreement. You acknowledge and agree that the company may, without
                    liability to you, access, use, preserve and/or disclose your account information
                    and input to law enforcement authorities, government officials, and/or a third
                    party, as the company believes is reasonably necessary or appropriate, if
                    legally required to do so or if we have a good faith belief that such access,
                    use, disclosure, or preservation is reasonably necessary to: (a) comply with
                    legal process or request; (b) enforce this agreement, including investigation of
                    any potential violation thereof; (c) detect, prevent or otherwise address
                    security, fraud or technical issues; or (d) protect the rights, property or
                    safety of the company, its users, a third party, or the public as required or
                    permitted by law.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Submissions
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    you acknowledge and agree that any questions, comments, suggestions, ideas,
                    feedback or other information about the website or the company services
                    (“submissions”) provided by you to the company are non-confidential and the
                    company (as well as any designee of the company) shall be entitled to the
                    unrestricted use and dissemination of these submissions for any purpose,
                    commercial or otherwise, without acknowledgment or compensation to you.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32 mb-0"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    App License
                  </div>
                  <div className="t-center color-1 rubik weight-500 f-32">Use License</div>
                  <span className="rubik weight-400 color-4 text-justify">
                    If you are accessing the company services via a mobile application, then the
                    company grants you a revocable, non-exclusive, non-transferable, limited right
                    to install and use the application on wireless handsets owned and controlled by
                    you, and to access and use the application on such devices strictly in
                    accordance with the terms and conditions of this license. You shall use the
                    application strictly in accordance with the terms of this license and shall not:
                    (a) decompile, reverse engineer, disassemble, attempt to derive the source code
                    of, or decrypt the application; (b) make any modification, adaptation,
                    improvement, enhancement, translation or derivative work from the application;
                    (c) violate any applicable laws, rules or regulations in connection with your
                    access or use of the application; (d) remove, alter or obscure any proprietary
                    notice (including any notice of copyright or trademark) of the company or its
                    affiliates, partners, suppliers or the licensors of the application; (e) use the
                    application for any revenue generating endeavor, commercial enterprise, or other
                    purpose for which it is not designed or intended; (f) make the application
                    available over a network or other environment permitting access or use by
                    multiple devices or users at the same time; (g) use the application for creating
                    a product, service or software that is, directly or indirectly, competitive with
                    or in any way a substitute for the application; (h) use the application to send
                    automated queries to any website or to send any unsolicited commercial e-mail;
                    or (i) use any proprietary information or interfaces of the company or other
                    intellectual property of the company in the design, development, manufacture,
                    licensing or distribution of any applications, accessories or devices for use
                    with the application. You acknowledge that the company may occasionally issue
                    upgraded versions of the application and may automatically electronically
                    upgrade the version of the application that you are using on your mobile device.
                    You consent to such automatic upgrading on your mobile device, and your
                    continued use of the application constitutes your agreement to the terms and
                    conditions of this agreement will apply to all such upgrades. There may be
                    open-source components in an application subject to certain open source license
                    terms or specific provisions, which will be referenced within the application,
                    and which will override these application license provisions.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Social Media
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    As part of the functionality of the website, you may link your account with
                    online accounts you may have with third party service providers (each such
                    account, a “third party account”) by either: (i) providing your third party
                    account login information through the Website; or (ii) allowing the company to
                    access your third party account, as is permitted under the applicable terms and
                    conditions that govern your use of each third party account. you represent that
                    you are entitled to disclose your third party account login information to the
                    company and/or grant the company access to your third party account (including,
                    but not limited to, for use for the purposes described herein), without breach
                    by you of any of the terms and conditions that govern your use of the applicable
                    third party account and without obligating the company to pay any fees or making
                    the company subject to any usage limitations imposed by such third party service
                    providers. by granting the company access to any third party accounts, you
                    understand that (i) the company may access, make available and store (if
                    applicable) any content that you have provided to and stored in your third party
                    account (the “social network content”) so that it is available on and through
                    the website via your account, including without limitation any friend lists, and
                    (ii) the company may submit and receive additional information to your third
                    party account to the extent you are notified when you link your account with the
                    third party account. depending on the third party accounts you choose and
                    subject to the privacy settings that you have set in such third party accounts,
                    personally identifiable information that you post to your third party accounts
                    may be available on and through your account on the website. please note that if
                    a third party account or associated service becomes unavailable or the company’s
                    access to such third party account is terminated by the third party service
                    provider, then social network content may no longer be available on and through
                    the website. you will have the ability to disable the connection between your
                    account on the website and your third party accounts at any time. PLEASE NOTE
                    THAT YOUR RELATIONSHIP WITH THE THIRD PARTY SERVICE PROVIDERS ASSOCIATED WITH
                    YOUR THIRD PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH
                    THIRD PARTY SERVICE PROVIDERS. the company makes no effort to review any social
                    network content for any purpose, including but not limited to, for accuracy,
                    legality or non-infringement, and the company is not responsible for any social
                    network content. you acknowledge and agree that the company may access your
                    e-mail address book associated with a third party account and your contacts list
                    stored on your mobile device or tablet computer solely for the purposes of
                    identifying and informing you of those contacts who have also registered to use
                    the website. at your request made via email to our email address listed below,
                    or through your account settings (if applicable), the company will deactivate
                    the connection between the website and your third party account and delete any
                    information stored on the company’s servers that was obtained through such third
                    party account, except the username and profile picture that become associated
                    with your account.
                    <br />
                    <br />
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Prohibited Activities
                  </div>
                  <span className="rubik weight-400 color-4 text-justify">
                    You may not access or use the website for any other purpose other than that for
                    which the company makes it available. the website may not be used in connection
                    with any commercial endeavors except those that are specifically endorsed or
                    approved by the company. prohibited activity includes, but is not limited to:
                    <br /> a. criminal or tortious activity;
                    <br />
                    b. systematic retrieval of data or other content from the website to create or
                    compile, directly or indirectly, a collection, compilation, database or
                    directory without written permission from the company;
                    <br />
                    c. making any unauthorized use of the the company services, including collecting
                    usernames and/or email addresses of users by electronic or other means for the
                    purpose of sending unsolicited email, or creating user accounts by automated
                    means or under false pretenses;
                    <br />
                    d. tricking, defrauding or misleading the company and other users, especially in
                    any attempt to deceive donors, learn sensitive account information such as
                    passwords;
                    <br />
                    e. engaging in any automated use of the system, such as using any data mining,
                    robots or similar data gathering and extraction tools;
                    <br />
                    f. interfering with, disrupting, or creating an undue burden on the website or
                    the networks or services connected to the website;
                    <br />
                    g. attempting to impersonate another user or person or using the username of
                    another user;
                    <br />
                    h. selling or otherwise transferring your profile;
                    <br />
                    i. using any information obtained from the website in order to harass, abuse, or
                    harm another person;
                    <br />
                    j. using the the company service as part of any effort to compete with the
                    company or to provide services as a service bureau;
                    <br />
                    k. deciphering, decompiling, disassembling or reverse engineering any of the
                    software comprising or in any way making up a part of the website;
                    <br />
                    l. attempting to bypass any measures of the website designed to prevent or
                    restrict access to the website, or any portion of the website;
                    <br />
                    m. harassing, annoying, intimidating or threatening any the company employees or
                    agents engaged in providing any portion of the the company services to you;
                    <br />
                    n. deleting the copyright or other proprietary rights notice from any website
                    content;
                    <br />
                    o. except as may be the result of standard search engine or internet browser
                    usage, using or launching, developing or distributing any automated system,
                    including, without limitation, any spider, robot (or “bot”), cheat utility,
                    scraper or offline reader that accesses the website, or using or launching any
                    unauthorized script or other software; or
                    <br /> p. using the website in a manner inconsistent with any and all applicable
                    laws and regulations. the the company service shall only be used for lawful
                    purposes and you shall use the the company service only in compliance with this
                    agreement and all other applicable u.s., state, local and international laws in
                    your jurisdiction, including: (1) the can-spam act; (2) canada’s anti-spam
                    legislation; (3) any policies and laws related to unsolicited emails, spamming,
                    privacy, obscenity, or defamation, copyright and trademark infringement and
                    child protective email address registry laws; (4) laws relating to advertising,
                    sales or promotional efforts or practices, redemption, refunds and provision of
                    your products or services; (5) laws that govern false, unfair and deceptive
                    practices, coupons, gift cards/certificates, defective products or services,
                    unclaimed property, alcohol or tobacco, health and safety, fire, and hygiene
                    standards; (6) laws that govern lotteries, sweepstakes, contests and promotions;
                    and (7) laws that govern the collection of donations and charitable giving. you
                    further agree to refrain from unethical, false or misleading advertising,
                    promotions or sales efforts and practices in connection with your use of the the
                    company service. you may not use the the company service for any unlawful or
                    discriminatory activities, including acts prohibited by the federal trade
                    commission act, fair credit reporting act, equal credit opportunity act, or
                    other laws that apply to commerce. The company content on the website is
                    provided to you “as is” for your information and personal use only and may not
                    be used, copied, reproduced, aggregated, distributed, transmitted, broadcast,
                    displayed, sold, licensed, or otherwise exploited for any other purposes
                    whatsoever without the prior written consent of the respective owners provided
                    that you are eligible to use the website, you are granted a limited license to
                    access and use the website and the company content and to download or print a
                    copy of any portion of the company content to which you have properly gained
                    access solely for your personal, non-commercial use. The company reserves all
                    rights not expressly granted to you in and to the website and the company
                    content and marks. You hereby give the company the right to use your business’
                    name, logos, trademarks, and service marks on the company’s customer lists which
                    may be displayed on the website and in other publications in whatever media
                    form.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Third Party Websites and Content
                  </div>
                  <span className="weight-400 rubik color-4">
                    The website contains (or you may be sent through the website or the the company
                    service) links to other websites (“third party websites”) as well as articles,
                    photographs, text, graphics, pictures, designs, music, sound, video,
                    information, applications, software and other content or items belonging to or
                    originating from third parties (the “third party content”). Such third party
                    websites and third party content are not investigated, monitored or checked for
                    accuracy, appropriateness, or completeness by us, and we are not responsible for
                    any third party websites accessed through the website or any third party content
                    posted on, available through or installed from the website, including the
                    content, accuracy, offensiveness, opinions, reliability, privacy practices or
                    other policies of or contained in the third party websites or the third party
                    content. Inclusion of, linking to or permitting the use or installation of any
                    third party website or any third party content does not imply approval or
                    endorsement thereof by us. If you decide to leave the website and access the
                    third party websites or to use or install any third party content, you do so at
                    your own risk and you should be aware that our terms and policies no longer
                    govern. You should review the applicable terms and policies, including privacy
                    and data gathering practices, of any website to which you navigate from the
                    website or relating to any applications you use or install from the website. Any
                    purchases you make through third party websites will be through other websites
                    and from other companies, and the company takes no responsibility whatsoever in
                    relation to such purchases which are exclusively between you and the applicable
                    third party.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Site Management
                  </div>
                  <span className="weight-400 rubik color-4">
                    The company reserves the right but does not have the obligation to:
                    <br />
                    A. Monitor the website for violations of this agreement;
                    <br />
                    B. Take appropriate legal action against anyone who, in the company’s sole
                    discretion, violates this agreement, including without limitation, reporting
                    such user to law enforcement authorities;
                    <br />
                    C. In the company’s sole discretion and without limitation, refuse, restrict
                    access to or availability of, or disable (to the extent technologically
                    feasible) any user’s contribution or any portion thereof that may violate this
                    agreement or any the company policy;
                    <br />
                    D. In the company’s sole discretion and without limitation, notice or liability
                    to remove from the website or otherwise disable all files and content that are
                    excessive in size or are in any way burdensome to the company’s systems;
                    <br /> E. Otherwise manage the website in a manner designed to protect the
                    rights and property of the company and others and to facilitate the proper
                    functioning of the website.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Privacy
                  </div>
                  <span className="weight-400 rubik color-4">
                    The privacy of our users is our top priority. Please review the company privacy
                    policy. By using the website or the company services, you are consenting to have
                    your personal data transferred to and processed in the United States. By using
                    the website or the company services, you are consenting to the terms of our
                    privacy policy.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    USER DATA
                  </div>
                  <span className="weight-400 rubik color-4">
                    Our website will maintain certain data that you transfer to the website for the
                    purpose of the performance of the company services, as well as data relating to
                    your use of the company services. Although we perform regular routine backups of
                    data, you are primarily responsible for all data that you have transferred or
                    that relates to any activity you have undertaken using the company services. You
                    agree that the company shall have no liability to you for any loss or corruption
                    of any such data, and you hereby waive any right of action against the company
                    arising from any such loss or corruption of such data.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Intellectual Property Rights
                  </div>
                  <span className="weight-400 rubik color-4">
                    The content on the website (“the company content”) and the trademarks, service
                    marks and logos contained therein (“marks”) are owned by or licensed to the
                    company and are subject to copyright and other intellectual property rights
                    under united states and foreign laws and international conventions. The company
                    content includes, without limitation, all source code, databases, functionality,
                    software, website designs, audio, video, text, photographs and graphics. All the
                    company graphics, logos, designs, page headers, button icons, scripts and
                    service names are registered trademarks, common law trademarks or trade dress of
                    the company in the U.S. And/or other countries. The company’s trademarks and
                    trade dress may not be used, including as part of trademarks and/or as part of
                    domain names, in connection with any product or service in any manner that is
                    likely to cause confusion and may not be copied, imitated, or used, in whole or
                    in part, without the prior written permission of the company.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Digital Millennium Copyright Act (DMCA) Notice and Policy
                  </div>
                  <div className="t-center rubik weight-500 color-1 f-32">Notifications</div>
                  <span className="weight-400 rubik color-4">
                    If you believe that content available on or through our website infringes one or
                    more of your copyrights, please immediately notify our copyright agent by mail,
                    email or faxed notice (“notification”) providing the information described
                    below, which notification is pursuant to DMCA 17 U.S.C. § 512(c)(3). A copy of
                    your notification will be sent to the person who posted or stored the material
                    addressed in the notification. Please be advised that pursuant to federal law
                    you may be held liable for damages if you make material misrepresentations in a
                    notification. Thus, if you are not sure that content located on or linked to by
                    our website infringes your copyright, you should consider first contacting an
                    attorney. Our website has a policy of terminating repeat infringers in
                    appropriate circumstances.
                    <br />
                    All notifications should include the following:
                    <br />
                    A. A physical or electronic signature of a person authorized to act on behalf of
                    the owner of an exclusive right that is allegedly infringed.
                    <br /> B. Identification of the copyrighted work claimed to have been infringed,
                    or, if multiple copyrighted works at a single online website are covered by a
                    single notification, a representative list of such works at that website.
                    <br /> C. Identification of the material that is claimed to be infringing or to
                    be the subject of infringing activity and that is to be removed or access to
                    which is to be disabled, and information reasonably sufficient to permit us to
                    locate the material.
                    <br />
                    D. Information reasonably sufficient to permit us to contact the complaining
                    party, such as an address, telephone number, and, if available, an electronic
                    mail address at which the complaining party may be contacted.
                    <br />
                    E. A statement that the complaining party has a good faith belief that use of
                    the material in the manner complained of is not authorized by the copyright
                    owner, its agent, or the law.
                    <br /> F. A statement that the information in the notification is accurate, and
                    under penalty of perjury, that the complaining party is authorized to act on
                    behalf of the owner of an exclusive right that is allegedly infringed.
                    <br />
                    Notifications should be sent to our copyright agent as follows:
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Copyright Agent
                  </div>
                  <span className="weight-400 rubik color-4">
                    Tomchei Tzedaka Corp DBA World of Tzedaka (“The company”) 16 Bridgewood Ave.,
                    Lakewood, NJ 08701 Email: Support@worldoftzedaka.org Phone: 732-307-8182 We also
                    will advise the alleged infringer of the DMCA statutory Counter Notification
                    procedure described below by which the alleged infringer may respond to your
                    claim and request that we restore this material.
                    <br />
                    <br />
                  </span>
                  <div className="t-center rubik weight-500 color-1 f-32">Counter Notification</div>
                  <span className="weight-400 rubik color-4">
                    If you believe your own copyrighted material has been removed from our website
                    and/or our service as a result of mistake or misidentification, you may submit a
                    written counter notification to our Designated Copyright Agent pursuant to DMCA
                    17 U.S.C. § 512(g)(2) and (3). To be an effective counter notification under the
                    DMCA, your counter notification must include substantially the following:
                    <br /> a. Identification of the material that has been removed or disabled and
                    the location at which the material appeared before it was removed or disabled.
                    <br /> B. A statement that you consent to the jurisdiction of the federal
                    district court in which your address is located, or if your address is outside
                    the United States, for any judicial district in which our the company is
                    located.
                    <br />
                    C. A statement that you will accept service of process from the party that filed
                    the notification or the party’s agent.
                    <br />
                    D. Your name, address and telephone number.
                    <br />
                    E. A statement under penalty of perjury that you have a good faith belief that
                    the material in question was removed or disabled as a result of mistake or
                    misidentification of the material to be removed or disabled.
                    <br />
                    F. Your physical or electronic signature. You may submit your counter
                    notification to our copyright agent by fax, mail, or email as set forth above.
                    If you send us a valid, written counter notification meeting the requirements
                    described above, we will restore your removed or disabled material after 10
                    business days but no later than 14 business days from the date we receive your
                    counter notification, unless our copyright agent first receives notice from the
                    party filing the original notification informing us that such party has filed a
                    court action to restrain you from engaging in infringing activity related to the
                    material in question. Please note that if you materially misrepresent that the
                    disabled or removed content was removed by mistake or misidentification, you may
                    be liable for damages, including costs and attorney’s fees. Filing a false
                    counter notification constitutes perjury.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    Length of Term and Termination
                  </div>
                  <span className="weight-400 rubik color-4">
                    This agreement shall remain in full force and effect while you use the website
                    or are otherwise a user or member of the website, as applicable. You may
                    terminate your use or participation at any time, for any reason, by following
                    the instructions for terminating user accounts in your account settings, if
                    available, or by contacting us using the contact information below.
                    <br /> WITHOUT LIMITING ANY OTHER PROVISION OF THIS AGREEMENT, THE COMPANY
                    RESERVES THE RIGHT TO, IN THE COMPANY’S SOLE DISCRETION AND WITHOUT NOTICE OR
                    LIABILITY, DENY ACCESS TO AND USE OF THE WEBSITE AND THE COMPANY SERVICES, TO
                    ANY PERSON FOR ANY REASON OR FOR NO REASON AT ALL, INCLUDING WITHOUT LIMITATION
                    FOR BREACH OF ANY REPRESENTATION, WARRANTY OR COVENANT CONTAINED IN THIS
                    AGREEMENT, OR OF ANY APPLICABLE LAW OR REGULATION, AND THE COMPANY MAY TERMINATE
                    YOUR USE OR PARTICIPATION IN THE WEBSITE AND THE COMPANY SERVICES, DELETE YOUR
                    PROFILE AND ANY CONTENT OR INFORMATION THAT YOU HAVE POSTED AT ANY TIME, WITHOUT
                    WARNING, IN THE COMPANY’S SOLE DISCRETION.
                    <br />
                    <br />
                    In order to protect the integrity of the website and the company services, the
                    company reserves the right at any time in its sole discretion to block certain
                    IP addresses from accessing the website and the company services.
                    <br />
                    Any provisions of this agreement that, in order to fulfill the purposes of such
                    provisions, need to survive the termination or expiration of this agreement,
                    shall be deemed to survive for as long as necessary to fulfill such purposes.
                    <br />
                    <br />
                    <span className="weight-600 rubik color-5">
                      YOU UNDERSTAND THAT CERTAIN STATES ALLOW YOU TO CANCEL THIS AGREEMENT, WITHOUT
                      ANY PENALTY OR OBLIGATION, AT ANY TIME PRIOR TO MIDNIGHT OF THE COMPANY’S
                      THIRD BUSINESS DAY FOLLOWING THE DATE OF THIS AGREEMENT, EXCLUDING SUNDAYS AND
                      HOLIDAYS. TO CANCEL, CALL THE COMPANY CUSTOMER CARE REPRESENTATIVE DURING
                      NORMAL BUSINESS HOURS USING THE CONTACT INFORMATION LISTING BELOW IN THIS
                      AGREEMENT OR BY ACCESSING YOUR ACCOUNT SETTINGS. THIS SECTION APPLIES ONLY TO
                      INDIVIDUALS RESIDING IN STATES WITH SUCH LAWS.
                    </span>
                    <br />
                    <br />
                    If the company terminates or suspends your account for any reason, you are
                    prohibited from registering and creating a new account under your name, a fake
                    or borrowed name, or the name of any third party, even if you may be acting on
                    behalf of the third party. In addition to terminating or suspending your
                    account, the company reserves the right to take appropriate legal action,
                    including without limitation pursuing civil, criminal, and injunctive redress.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    MODIFICATIONS
                  </div>
                  <div className="t-center rubik weight-500 color-1 f-32">To Agreement</div>
                  <span className="weight-400 color-4 rubik">
                    The company may modify this agreement from time to time. Any and all changes to
                    this agreement will be posted on the website and revisions will be indicated by
                    date. You agree to be bound to any changes to this agreement when you use the
                    company services after any such modification becomes effective. The company may
                    also, in its discretion, choose to alert all users with whom it maintains email
                    information of such modifications by means of an email to their most recently
                    provided email address. It is therefore important that you regularly review this
                    agreement and keep your contact information current in your account settings to
                    ensure you are informed of changes. You agree that you will periodically check
                    the website for updates to this agreement and you will read the messages we send
                    you to inform you of any changes. Modifications to this agreement shall be
                    effective after posting.
                  </span>
                  <div className="t-center rubik weight-500 color-1 f-32"> To Services</div>
                  <span className="weight-400 color-4 rubik">
                    The company reserves the right at any time to modify or discontinue, temporarily
                    or permanently, the company services (or any part thereof) with or without
                    notice. You agree that the company shall not be liable to you or to any third
                    party for any modification, suspension or discontinuance of the the company
                    services.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    {" "}
                    DISPUTES
                  </div>
                  <div className="t-center rubik weight-500 color-1 f-32"> Between Users</div>
                  <span className="weight-400 color-4 rubik">
                    If there is a dispute between users of the website, or between users and any
                    third party, you understand and agree that the company is under no obligation to
                    become involved. In the event that you have a dispute with one or more other
                    users, you hereby release the company, its officers, employees, agents and
                    successors in rights from claims, demands and damages (actual and consequential)
                    of every kind or nature, known or unknown, suspected and unsuspected, disclosed
                    and undisclosed, arising out of or in any way related to such disputes and/or
                    the company services. The ultimate decision lies with the company leadership.
                    With The company All disputes with the company will be decided by the company
                    leadership. If you are not satisfied with the company decision, all cases will
                    only be handled by Bais Din Maysharim (Jewish Court) 625 Forest Ave Lakewood, NJ
                    08701 with no exceptions.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    {" "}
                    CORRECTIONS
                  </div>
                  <span className="weight-400 color-4 rubik">
                    Occasionally there may be information on the website that contains typographical
                    errors, inaccuracies or omissions that may relate to service descriptions,
                    pricing, availability, and various other information. The company reserves the
                    right to correct any errors, inaccuracies or omissions and to change or update
                    the information at any time, without prior notice.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    DISCLAIMERS
                  </div>
                  <span className="weight-400 color-4 rubik">
                    <br />
                    The company cannot control the nature of all of the content available on the
                    website. By operating the website, the company does not represent or imply that
                    the company endorses any content available on or linked to by the website,
                    including without limitation content hosted on third party websites or provided
                    by third party applications, or that the company believes content to be
                    accurate, useful or non-harmful. The company is not responsible for the conduct,
                    whether online or offline, of any user of the website or the company services.
                    <br /> YOU AGREE THAT YOUR USE OF THE WEBSITE AND THE COMPANY SERVICES WILL BE
                    AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, THE COMPANY, ITS
                    OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS DISCLAIM ALL WARRANTIES, EXPRESS OR
                    IMPLIED, IN CONNECTION WITH THE WEBSITE AND THE COMPANY SERVICES AND YOUR USE
                    THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
                    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. THE
                    COMPANY MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR
                    COMPLETENESS OF THE WEBSITE’S CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO
                    THIS WEBSITE AND ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY (A) ERRORS,
                    MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (B) PERSONAL INJURY OR
                    PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE
                    OF OUR WEBSITE, (C) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS
                    AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED
                    THEREIN, (D) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE
                    WEBSITE OR THE COMPANY SERVICES, (E) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE
                    LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE WEBSITE BY ANY THIRD PARTY,
                    AND/OR (F) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS
                    OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF ANY CONTENT POSTED, TRANSMITTED,
                    OR OTHERWISE MADE AVAILABLE VIA THE WEBSITE OR FROM ANY USE OF THE COMPANY
                    SERVICES. THE COMPANY DOES NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME
                    RESPONSIBILITY FOR ANY CAMPAIGN ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH
                    THE WEBSITE OR ANY HYPERLINKED WEBSITE OR FEATURED IN ANY BANNER OR OTHER
                    ADVERTISING, AND THE COMPANY WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE
                    FOR MONITORING ANY TRANSACTION BETWEEN YOU AND FUNDRAISERS. AS WITH THE PURCHASE
                    OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE
                    YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.
                    <br />
                    YOU ARE SOLELY RESPONSIBLE FOR ALL OF YOUR COMMUNICATIONS AND INTERACTIONS WITH
                    OTHER USERS OF THE COMPANY SERVICE AND WITH OTHER PERSONS WITH WHOM YOU
                    COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE COMPANY SERVICE. YOU
                    UNDERSTAND THAT THE COMPANY DOES NOT MAKE ANY ATTEMPT TO VERIFY THE STATEMENTS
                    OF USERS OF THE COMPANY SERVICE AND THE COMPANY IS NOT RESPONSIBLE FOR THE
                    ACTION OF USERS OF THE COMPANY SERVICE.
                    <div
                      className="t-center rubik weight-500 color-1 f-32"
                      style={{ marginTop: "10px", marginBottom: "10px" }}
                    >
                      LIMITATIONS OF LIABILITY
                    </div>
                    <br /> IN NO EVENT SHALL THE COMPANY OR ITS DIRECTORS, EMPLOYEES, OR AGENTS BE
                    LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL,
                    EXEMPLARY, INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST
                    REVENUE, LOSS OF DATA OR OTHER DAMAGES ARISING FROM YOUR USE OF THE WEBSITE OR
                    THE COMPANY SERVICES, EVEN IF THE COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF
                    SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, THE
                    COMPANY’S LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM
                    OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU
                    TO THE COMPANY FOR THE COMPANY SERVICES DURING THE PERIOD OF 3 MONTHS PRIOR TO
                    ANY CAUSE OF ACTION ARISING OR $10, WHICHEVER IS GREATER.
                    <br /> CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE
                    EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR
                    ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY
                    HAVE ADDITIONAL RIGHTS.
                    <br /> IF YOU ARE A CALIFORNIA RESIDENT, YOU WAIVE CALIFORNIA CIVIL CODE SECTION
                    1542, WHICH SAYS: “A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE
                    CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING
                    THE RELEASE, WHICH, IF KNOWN BY HIM MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT
                    WITH THE DEBTOR.”
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    INDEMNITY
                  </div>
                  <span className="weight-400 color-4 rubik">
                    You agree to defend, indemnify and hold the company, its subsidiaries, and
                    affiliates, and their respective officers, agents, partners and employees,
                    harmless from and against, any loss, damage, liability, claim, or demand,
                    including reasonable attorneys’ fees and expenses, made by any third party due
                    to or arising out of your contributed content, use of the company services,
                    and/or arising from a breach of this agreement and/or any breach of your
                    representations and warranties set forth above. The company will use reasonable
                    efforts to notify you of any such claim, action, or proceeding which is subject
                    to this indemnification upon becoming aware of it.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    NOTICES
                  </div>
                  <span className="weight-400 color-4 rubik">
                    Except as explicitly stated otherwise, any notices given to the company shall be
                    given by email to the address listed in the contact information below. Any
                    notices given to you shall be given to the email address you provided during the
                    registration process, or such other address as each party may specify. Notice
                    shall be deemed to be given 24 hours after the email is sent, unless the sending
                    party is notified that the email address is invalid. We may also choose to send
                    notices by regular mail.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    ELECTRONIC CONTRACTING
                  </div>
                  <span className="weight-400 color-4 rubik">
                    Your use of the company service includes the ability to enter into agreements
                    and/or to make transactions electronically. YOU ACKNOWLEDGE THAT YOUR ELECTRONIC
                    SUBMISSIONS CONSTITUTE YOUR AGREEMENT AND INTENT TO BE BOUND BY AND TO PAY FOR
                    SUCH AGREEMENTS AND TRANSACTIONS. YOUR AGREEMENT AND INTENT TO BE BOUND BY
                    ELECTRONIC SUBMISSIONS APPLIES TO ALL RECORDS RELATING TO ALL TRANSACTIONS YOU
                    ENTER INTO RELATING TO THE COMPANY SERVICE, INCLUDING NOTICES OF CANCELLATION,
                    POLICIES, CONTRACTS, AND APPLICATIONS. In order to access and retain your
                    electronic records, you may be required to have certain hardware and software,
                    which are your sole responsibility.
                  </span>
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    PROHIBITED CONDUCT
                  </div>
                  You are solely responsible for compliance with all applicable law in relation to
                  your fundraiser or use of the services. You are further solely responsible for all
                  user content that you upload, post, publish, display, transmit or otherwise use.
                  If you are not the beneficiary of the fundraiser you organize, you agree to
                  deliver funds to the ultimate beneficiary directly and as soon as possible. You
                  agree to fully cooperate with any request we make for evidence we deem necessary
                  to verify your compliance with these terms of service. The following are examples
                  of user content and/or use that is illegal or prohibited by worldoftzedaka.org
                  this list is not exhaustive, and we reserve the right to remove any fundraiser
                  and/or investigate any user who, in our sole discretion, violates any of the terms
                  or spirit of these terms of service. As we investigate your fundraiser, a user, or
                  user content, we may consider all available material including but not limited to
                  social media, related news, and any other information that we, in our sole
                  discretion, deem relevant in our review. We further reserve the right, without
                  limitation, to ban or disable your use of the services, remove the offending user
                  content, suspend or terminate your account, stop payments to any such fundraiser,
                  freeze or place a hold on donations, and report you to law enforcement authorities
                  or otherwise take appropriate legal action including seeking restitution on behalf
                  of ourselves and/or our users.
                  <br />
                  Without limiting the foregoing, you agree and represent, warrant and covenant:
                  <div className="title-terms clause-first">
                    1. Not to use the services to raise funds or establish or contribute to any
                    fundraiser with the implicit or explicit purpose of promoting or involving:
                  </div>
                  <div className="title-terms clause-second">
                    1. The violation of any law, regulation, industry requirement, or third-party
                    guidelines or agreements by which you are bound, including those of payment card
                    providers and transaction processors that you utilize in connection with the
                    services;
                  </div>
                  <div className="title-terms clause-second">
                    2. Any election campaigns that are not run by a registered organization within
                    the supported country;
                  </div>
                  <div className="title-terms clause-second">
                    3. User content or fundraisers that are fraudulent, misleading, inaccurate,
                    dishonest, or impossible;
                  </div>
                  <div className="title-terms clause-second">
                    4. Drugs, narcotics, steroids, controlled substances, pharmaceuticals or similar
                    products or therapies that are either illegal, prohibited, or enjoined by an
                    applicable regulatory body; legal substances that provide the same effect as an
                    illegal drug; or other products, medical practices, or any related equipment or
                    paraphernalia that have been found by an applicable regulatory body to cause
                    consumer harm;
                  </div>
                  <div className="title-terms clause-second">
                    5. Knives, explosives, ammunition, firearms, or other weaponry or accessories;
                  </div>
                  <div className="title-terms clause-second">
                    6. Annuities, investments, loans, equity or lottery contracts, lay-away systems,
                    off-shore banking or similar transactions, money service businesses (including
                    currency exchanges, check cashing or the like), pyramid schemes, “get rich quick
                    schemes” (i.e., investment opportunities or other services that promise high
                    rewards), network marketing and referral marketing programs, debt collection or
                    crypto-currencies;
                  </div>
                  <div className="title-terms clause-second">
                    7. Gambling, gaming and/or any other activity with an entry fee and a prize,
                    including, but not limited to raffles, casino games, sports betting, fantasy
                    sports, horse or greyhound racing, lottery tickets, raffle tickets, auctions and
                    other ventures that facilitate gambling, games of skill or chance (whether or
                    not it is legally defined as a lottery), promotions involving monetary rewards,
                    including gift cards, or sweepstakes;
                  </div>
                  <div className="title-terms clause-second">
                    8. User content that reflects or promotes behavior that we deem, in our sole
                    discretion, to be an abuse of power or in support of hate, violence, harassment,
                    bullying, discrimination, terrorism, or intolerance of any kind relating to
                    race, ethnicity, national origin, religious affiliation, sexual orientation,
                    sex, gender, gender identity, gender expression, serious disabilities or
                    diseases;
                  </div>
                  <div className="title-terms clause-second">
                    9. The legal defense of alleged crimes associated with hate, violence,
                    harassment, bullying, discrimination, terrorism, or intolerance of any kind
                    relating to race, ethnicity, national origin, religious affiliation, sexual
                    orientation, sex, gender, gender identity, gender expression, serious
                    disabilities or diseases, financial crimes or crimes of deception;
                  </div>
                  <div className="title-terms clause-second">
                    10. Activities with, in, or involving countries, regions, governments, persons,
                    or entities that are subject to U.S. and other economic sanctions under
                    applicable law, unless such activities are expressly authorized by the
                    appropriate governmental authority;
                  </div>
                  <div className="title-terms clause-second">
                    11. The funding of a ransom, human trafficking or exploitation, vigilantism,
                    bribes or bounty;
                  </div>
                  <div className="title-terms clause-second">
                    12. Pornography or other sexual content;
                  </div>
                  <div className="title-terms clause-second">
                    13. Offensive, graphic, perverse or sensitive content;
                  </div>
                  <div className="title-terms clause-second">
                    14. The collecting of payments on behalf of merchants by payment processors or
                    otherwise; including but not limited to self-payments on fundraisers or an
                    attempt to bypass or otherwise circumvent the designated method of payment as
                    provided by worldoftzedaka.org;
                  </div>
                  <div className="title-terms clause-second">
                    15. Credit repair or debt settlement services;
                  </div>
                  <div className="title-terms clause-second">
                    16. The receipt or grant of cash advances or lines of credit to yourself or to
                    another person for purposes other than those purposes clearly stated in the
                    fundraiser;
                  </div>
                  <div className="title-terms clause-second">
                    17. Publication of user content (such as mug shots), where we deem, in our sole
                    discretion, that the primary purpose of posting such user content is to cause
                    reputational harm;
                  </div>
                  <div className="title-terms clause-second">
                    18. The sale or resale of a good or service;
                  </div>
                  <div className="title-terms clause-second">
                    19. The aggregation of funds owed to third parties, factoring, or other
                    activities intended to obfuscate the origin of funds;
                  </div>
                  <div className="title-terms clause-second">
                    20. Counterfeit music, movies, software, or other licensed materials without the
                    appropriate authorization from the rights holder;
                  </div>
                  <div className="title-terms clause-second">
                    21. Products or services that directly infringe or facilitate infringement upon
                    the trademark, patent, copyright, trade secrets, or proprietary or privacy
                    rights of any third party;
                  </div>
                  <div className="title-terms clause-second">
                    22. The unauthorized sale or resale of brand name or designer products or
                    services;
                  </div>
                  <div className="title-terms clause-second">
                    23. The sale of goods or services that are illegally imported or exported;
                  </div>
                  <div className="title-terms clause-second">
                    24. Processing, where there is no bona fide donation accepted; cash advance;
                    card testing; evasion of card network chargeback monitoring programs;
                  </div>
                  <div className="title-terms clause-second">
                    25. The collecting or providing of funds for any purpose other than as described
                    in a fundraiser description;
                  </div>
                  <div className="title-terms clause-second">
                    26. Any other activity that worldoftzedaka.org may deem, in its sole discretion,
                    to be in support of individuals and/or entities associated with alleged
                    financial crimes including but not limited to corruption, bribery, tax evasion,
                    fraud, and activities of a similar nature; or
                  </div>
                  <div className="title-terms clause-second">
                    27. Any other activity that worldoftzedaka.org may deem, in its sole discretion,
                    to be unacceptable.
                  </div>
                  <div className="title-terms clause-first">
                    2. Not to use the services to transmit or otherwise upload any user content that
                    (i) infringes any intellectual property or other proprietary rights of any
                    party; (ii) you do not have a right to upload under any law or under contractual
                    or fiduciary relationships; (iii) contains software viruses or any other
                    computer code, files or programs designed to interrupt, destroy or limit the
                    functionality of any computer software or hardware or telecommunications
                    equipment; (iv) poses or creates a privacy or security risk to any person; (v)
                    constitutes unsolicited or unauthorized advertising, promotional materials,
                    commercial activities and/or sales, “junk mail,” “spam,” “chain letters,”
                    “pyramid schemes,” “contests,” “sweepstakes,” or any other form of solicitation;
                    or (vi) in the sole judgment of worldoftzedaka.org is objectionable or which
                    restricts or inhibits any other person from using or enjoying the services, or
                    which may expose worldoftzedaka.org or its users to any harm or liability of any
                    type;
                  </div>
                  <div className="title-terms clause-first">
                    3. Not to interfere with or disrupt servers or networks connected to or used to
                    provide the services or their respective features, or disobey any requirements,
                    procedures, policies or regulations of the networks connected to or used to
                    provide the services;
                  </div>
                  <div className="title-terms clause-first">
                    4. Not to harvest, collect or publish personally identifiable information of
                    others;
                  </div>
                  <div className="title-terms clause-first">
                    5. Not to raise funds for a minor without the express permission of the minor’s
                    guardian unless the funds are transferred into a trust account for the sole
                    benefit of the minor;
                  </div>
                  <div className="title-terms clause-first">
                    6. Not to use the services on behalf of a third party or post any personal data
                    or other information about a third party, without the express consent of that
                    third party;
                  </div>
                  <div className="title-terms clause-first">
                    {" "}
                    7. Not to use another user’s account or URL without permission, impersonate any
                    person or entity, falsely state or otherwise misrepresent your affiliation with
                    a person or entity, misrepresent a charity or fundraiser through the services,
                    or post user content in any inappropriate category or areas on the services;
                  </div>
                  <div className="title-terms clause-first">
                    8. Not to create any liability for worldoftzedaka.org or cause us to lose (in
                    whole or in part) the services of our internet service provider(s), web hosting
                    the company or any other vendors or suppliers;
                  </div>
                  <div className="title-terms clause-first">
                    {" "}
                    9. Not to engage in any conduct that, in worldoftzedaka.org sole judgment and
                    discretion, restricts or inhibits any other user from using or enjoying the
                    services;
                  </div>
                  <div className="title-terms clause-first">
                    {" "}
                    10. Not to gain unauthorized access to the services, or any account, computer
                    system, or network connected to the services, by any unauthorized or illegal
                    means;
                  </div>
                  <div className="title-terms clause-first">
                    {" "}
                    11. Not to obtain or attempt to obtain any materials or information not
                    intentionally made available through the services;
                  </div>
                  <div className="title-terms clause-first">
                    {" "}
                    12. Not to use the services to post, transmit or in any way exploit any
                    information, software or other material for commercial purposes, or that contain
                    advertising, except that using the services for fundraising activities in
                    accordance with these terms of service is expressly permitted;
                  </div>
                  <div className="title-terms clause-first">
                    {" "}
                    13. Not to transmit more request messages through the services in a given period
                    of time than a human can reasonably produce in the same period by using a
                    conventional online web browser;
                  </div>
                  <div className="title-terms clause-first">
                    {" "}
                    14. Not to undertake any activity or engage in any conduct that is inconsistent
                    with the business or purpose of the services; or
                  </div>
                  <div className="title-terms clause-first">
                    {" "}
                    15. Not to attempt to undertake indirectly any of the foregoing. Additionally,
                    with respect to all donations you make or accept through the services, you agree
                    and represent, warrant and covenant:
                  </div>
                  <div className="title-terms clause-second">
                    {" "}
                    1. Not to make or accept any donations that you know or suspect to be erroneous,
                    suspicious or fraudulent;
                  </div>
                  <div className="title-terms clause-second">
                    {" "}
                    2. Not to use the services in or for the benefit of a country, organization,
                    entity, or person embargoed or blocked by any government, including those on
                    sanctions lists identified by the United States Office of Foreign Asset Control
                    (OFAC);
                  </div>
                  <div className="title-terms clause-second">
                    {" "}
                    3. To maintain reasonable and standard security measures to protect any
                    information transmitted and received through the services, including without
                    limitation, adhering to any security procedures and controls required by
                    worldoftzedaka.org on occasion;
                  </div>
                  <div className="title-terms clause-second">
                    {" "}
                    4. To maintain a copy of all electronic and other records related to fundraisers
                    and donations as necessary for worldoftzedaka.org to verify compliance with
                    these terms of service and make such records available to worldoftzedaka.org
                    upon our request. For clarity, the foregoing does not affect or limit your
                    obligations to maintain documentation as required by applicable laws, rules,
                    regulations, or governmental authority; and
                  </div>
                  <div className="title-terms clause-second">
                    {" "}
                    5. At worldoftzedaka.org’s request, to fully cooperate in the auditing of,
                    investigation of (including without limitation, investigations by
                    worldoftzedaka.org, a payment processor, or a regulatory or governmental
                    authority), and remedial efforts to correct any alleged or uncovered violation
                    or wrongdoing of a user to whom, or fundraiser or donation to which, you are
                    connected.
                  </div>
                  Worldoftzedaka.org reserves the right to refuse, condition, or suspend any
                  donations or other transactions that we believe in our sole discretion may violate
                  these terms of service or harm the interests of our users, business partners, the
                  public, or worldoftzedaka.org, or that expose you, worldoftzedaka.org, or others
                  to risks unacceptable to us. We may share any information related to your use of
                  the services with the appropriate financial institution, regulatory authority, or
                  law enforcement agency consistent with our legal or contractual obligations. This
                  information may include information about you, your account, your donors, your
                  donations, and transactions made through or in connection with your use of the
                  services.
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    MISCELLANEOUS
                  </div>
                  This agreement constitutes the entire agreement between you and the company
                  regarding the use of the the company services. The failure of the company to
                  exercise or enforce any right or provision of this agreement shall not operate as
                  a waiver of such right or provision. The section titles in this agreement are for
                  convenience only and have no legal or contractual effect. This agreement operates
                  to the fullest extent permissible by law. This agreement and your account may not
                  be assigned by you without our express written consent. The company may assign any
                  or all of its rights and obligations to others at any time. The company shall not
                  be responsible or liable for any loss, damage, delay or failure to act caused by
                  any cause beyond the company’s reasonable control. If any provision or part of a
                  provision of this agreement is unlawful, void or unenforceable, that provision or
                  part of the provision is deemed severable from this agreement and does not affect
                  the validity and enforceability of any remaining provisions. Upon the company’s
                  request, you will furnish the company any documentation, substantiation or
                  releases necessary to verify your compliance with this agreement. You agree that
                  this agreement will not be construed against the company by virtue of having
                  drafted it. You hereby waive any and all defenses you may have based on the
                  electronic form of this agreement and the lack of signing by the parties hereto to
                  execute this agreement.
                  <div
                    className="t-center rubik weight-500 color-1 f-32"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    CONTACT US
                  </div>
                  In order to resolve a complaint regarding the company services or to receive
                  further information regarding use of the company services, please contact the
                  company as set forth below or, if any complaint with us is not satisfactorily
                  resolved, and you are a California resident, you can contact the Complaint
                  Assistance Unit of the Division of Consumer Services of the Department of Consumer
                  Affairs in writing at 400 R Street, Suite 1080, Sacramento, CA 95814-6200, or by
                  telephone at 1-800-952-5210.
                  <br />
                  Tomchei Tzedaka Corp DBA World of Tzedaka
                  <br />
                  Email: Support@worldoftzedaka.org
                  <br />
                  Phone: 732-307-8182
                </div>
              </div>
              <img src="/img/cross.png" style={{ width: '22px', cursor: 'pointer', position: "absolute", top: "0", right: '0' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
